var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.loading}},[_c('add-update-resource',{ref:"newResourceForm",attrs:{"updating-resource":_vm.resource},on:{"update":_vm.onUpdateResource}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }